import React, { useState, useEffect } from "react";
import "./Room.scss";
import ShowImage from "../ShowImage";
import BackBtn from "../../btncomponent/BackBtn";
import Footer from "../Footer";
import { Link } from "react-router-dom";

const Room = (props) => {
  const [room, setRoom] = useState({});
  const [loading, setLoading] = useState(false);
  const [exist, setExist] = useState({});

  useEffect(() => {
    const roomid = props.match.params.roomId;
    setLoading(true);
    const fetchdata = () => {
      fetch(`${process.env.REACT_APP_API_URL}/home/${roomid}`, {
        method: "GET",
      })
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          if (data.error) {
            console.log(data.error);
          } else {
            setRoom(data);
            setLoading(false);
          }
        });
    };
    fetchdata();

    fetch(`${process.env.REACT_APP_API_URL}/roombook/already/${roomid}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setExist(data[0]), setLoading(false);
      });
  }, [props]);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow spinner-grow-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );

  return (
    <div>
      <div className="container mt-3">
        <BackBtn location="/" />
        {showloading()}
        <div className="row">
          <div className="col-sm-5 mt-4">
            <ShowImage url="home" item={room} />
            <div style={{ backgroundColor: "#F8F8F6", padding: "5%" }}>
              <h4>{room.name}</h4>
              <p>{room.description}</p>
              <h5>
                <img
                  src="https://img.icons8.com/color/35/000000/key-exchange.png"
                  alt="icon"
                />{" "}
                Rent: {room.price}/Month
              </h5>
              <p className="text-muted">
                {" "}
                <img
                  src="https://img.icons8.com/fluent/25/000000/walking.png"
                  alt="icon"
                />
                {room.distance && `${room.distance}`}
              </p>

              <button
                className="btn btn-primary mr-3 "
                data-toggle="modal"
                data-target="#staticBackdrop"
                style={{ borderRadius: "0" }}
              >
                Enquire
              </button>

              {/*---Modal --- */}

              <div
                className="modal fade"
                id="staticBackdrop"
                data-backdrop="static"
                data-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div
                      className="modal-header"
                      style={{ backgroundColor: "#ffd700" }}
                    >
                      <h5 className="modal-title" id="staticBackdropLabel">
                        Enquire
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body text-center">
                      <a
                        href="https://api.whatsapp.com/send?phone=+917318735454"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://img.icons8.com/color/50/000000/whatsapp.png"
                          alt="wp"
                          className="wproom"
                        />
                      </a>

                      <a
                        className="ml-3"
                        href="tel:7318735454"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="https://img.icons8.com/doodle/40/000000/outgoing-call.png"
                          alt="phone"
                          className="phoneroom"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {exist && exist.roomimgid === room._id ? (
                ""
              ) : (
                <Link to={`/book/${room._id}`}>
                  <button
                    className="btn"
                    style={{ backgroundColor: "#FCCE01", borderRadius: "0" }}
                  >
                    Book Now
                  </button>
                </Link>
              )}

              <br />
              <h6 className="font-weight-normal mt-2">Basic information</h6>
              {room.bedroom && (
                <>
                  <img
                    src="https://img.icons8.com/windows/24/000000/bed.png"
                    alt="icon"
                  />{" "}
                  {room.bedroom}
                </>
              )}
              <br />

              {room.kitchen && (
                <>
                  <img
                    src="https://img.icons8.com/material-outlined/24/000000/kitchen.png"
                    alt="icon"
                  />{" "}
                  {room.kitchen}
                </>
              )}

              <br />

              {room.bathroom && (
                <>
                  <img
                    src="https://img.icons8.com/metro/24/000000/shower.png"
                    alt="icon"
                  />
                  {room.bathroom}
                </>
              )}
            </div>
            {room.map && (
              <>
                <div style={{ padding: "5%" }} className="mb-2 mt-2">
                  <h6 className="">
                    {" "}
                    <img
                      src="https://img.icons8.com/officel/24/000000/worldwide-location.png"
                      alt="icon"
                    />{" "}
                    Location{" "}
                  </h6>
                  <br />
                  <iframe title="map" className="mt-2" src={room.map}></iframe>
                </div>{" "}
              </>
            )}
          </div>

          <div className="col-sm-7 mt-4"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Room;
